
import Footer from '../components/Footer.vue';
import { debounce } from 'lodash/index';
import {
	onMounted,
	onUnmounted,
	Ref,
	ref,
} from 'vue';
import lottie1 from '../assets/images/lottie/hnu_lottie.json';
import lottie2 from '../assets/images/lottie/jvmp_lottie.json';
import log from '@/global/log';
export default {
	name: 'home',
	components: { Footer },
	setup() {
		let aboutHover = ref(true);
		let healthHover = ref(false);
		let jvmphHover = ref(false);

		let healthFadeUp = ref(false);
		let jvmpFadeUp = ref(false);

		//타이밍 때문에 따로 추가
		let healthLottie = ref(false);

		let inMove = ref(false);
		let activeSection = ref(0);
		let offsets: Ref<number[]> = ref([]);
		let touchStartY = ref(0);

		let isPc = ref(true);

		/**hover event */
		function hoverFn(event: Event) {
			log('hover');
			if (inMove.value) return;
			const el = event.target as HTMLElement;
			// log('hover' + el.className);
			if (el.className.includes('healthU')) {
				aboutHover.value = false;
				healthHover.value = true;
				jvmphHover.value = false;

				healthLottie.value = true;

				setTimeout(() => {
					healthFadeUp.value = true;
				}, 2500);
				log('헬스케어 플랫폼 hover');
			} else if (
				el.className.includes('virtual')
			) {
				aboutHover.value = false;
				healthHover.value = false;
				jvmphHover.value = true;
				setTimeout(() => {
					jvmpFadeUp.value = true;
				}, 300);

				log('모바일가상화 hover');
			} else {
				aboutHover.value = true;
				healthHover.value = false;
				jvmphHover.value = false;
				log('이외 영역 hover');
			}
		}

		/** fullpage offset구하기 */
		function calculateSectionOffsets() {
			log('fullpage offset구함');
			const sections =
				document.getElementsByClassName(
					'fullpage'
				) as unknown as HTMLElement[];
			const length = sections.length;
			log(
				'fullpage count' + sections.length,
				sections
			);
			for (let i = 0; i < length; i++) {
				const sectionOffset: number =
					sections[i].offsetTop;
				offsets.value.push(sectionOffset);
			}
		}

		/** 마우스휠 이벤트 */
		const handleMouseWheel = (e: WheelEvent) => {
			// log('scroll');
			e.preventDefault();
			// log(
			// 	'handleMouseWheel start activeSection' +
			// 		activeSection.value
			// );
			// log(
			// 	'handleMouseWheel start inMove ' +
			// 		inMove.value
			// );
			// log(
			// 	'handleMouseWheel start touchStartY ' +
			// 		touchStartY.value
			// );

			touchStartY.value = e.detail;

			if (
				e.deltaY < touchStartY.value &&
				!inMove.value
			) {
				moveUp();
			} else if (
				e.deltaY > touchStartY.value &&
				!inMove.value
			) {
				moveDown();
			}

			touchStartY.value = 0;
			e.preventDefault();
			// log('scroll end');
			return false;
		};

		function handleMouseWheelDOM(e: Event) {
			e.preventDefault();
			log('handleMouseWheelDOM start');

			touchStartY.value = (
				e as WheelEvent
			).detail;

			if (
				(e as WheelEvent).detail >
					touchStartY.value &&
				!inMove.value
			) {
				moveUp();
			} else if (
				(e as WheelEvent).detail <
					touchStartY.value &&
				!inMove.value
			) {
				moveDown();
			}
			touchStartY.value = 0;
			return false;
		}
		function moveDown() {
			log(
				'moveDown activeSection' +
					activeSection.value
			);
			inMove.value = true;
			if (
				activeSection.value ==
				offsets.value.length - 1
			) {
				inMove.value = false;
				return;
			} else {
				scrollToSection(
					activeSection.value,
					false
				);
			}

			// if (activeSection.value < 0)
			// 	activeSection.value =
			// 		offsets.value.length - 1;
		}
		function moveUp() {
			log(
				'moveUP activeSection ' +
					activeSection.value
			);
			inMove.value = true;
			if (activeSection.value == 0) {
				inMove.value = false;
				return;
			} else {
				scrollToSection(
					activeSection.value,
					true
				);
			}

			// if (
			// 	activeSection.value >
			// 	offsets.value.length - 1
			// )
			// 	activeSection.value = 0;
		}
		function scrollToSection(
			index: number,
			isUp: boolean
		) {
			log('scrollToSection11');
			const section =
				document.getElementsByClassName(
					'fullpage'
				)[isUp ? index - 1 : index + 1];

			log(
				'scrollToSection 33 section index enabled ',
				section
			);
			if (section) {
				section.scrollIntoView({
					behavior: 'smooth',
				});
				if (isUp) {
					activeSection.value--;
				} else {
					activeSection.value++;
				}

				//모바일 로티 있을때 ( pc와 충돌해서 주석처리)
				// if (activeSection.value == 1) {
				// 	setTimeout(() => {
				// 		healthFadeUp.value = true;
				// 	}, 2500);
				// 	healthHover.value = true;
				// } else if (activeSection.value == 2) {
				// 	jvmpFadeUp.value = true;
				// 	jvmphHover.value = true;
				// }
				log(
					'scrollToSection22 end touchStartY ' +
						touchStartY.value
				);
			}
			setTimeout(() => {
				inMove.value = false;
			}, 500);
		}

		function touchStart(e: TouchEvent) {
			log('layout touchStart ');
			log(
				'layout touch tag',
				(
					e.changedTouches[0]
						.target as HTMLElement
				).tagName
			);
			log(
				'layout touch tag class',
				(
					e.changedTouches[0]
						.target as HTMLElement
				).classList
			);

			if (
				(
					e.changedTouches[0]
						.target as HTMLElement
				).tagName != 'BUTTON'
			) {
				e.preventDefault();

				touchStartY.value = e.touches[0].clientY;
			}
		}

		function touchMove(e: TouchEvent) {
			if (inMove.value) return false;
			e.preventDefault();
			log('touchMove start');

			const currentY = e.touches[0].clientY;

			if (touchStartY.value < currentY) {
				moveUp();
			} else {
				moveDown();
			}

			return false;
		}

		onMounted(() => {
			log('onMounted');

			const screenWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			if (screenWidth < 1280) {
				isPc.value = false;
			} else {
				isPc.value = true;
			}

			window.addEventListener('resize', () => {
				window.scrollTo(0, 0);
				activeSection.value = -1;
				scrollToSection(-1, false);
				const screenWidth =
					window.innerWidth ||
					document.documentElement.clientWidth ||
					document.body.clientWidth;
				healthHover.value = false;
				jvmphHover.value = false;

				healthFadeUp.value = false;
				jvmpFadeUp.value = false;
				if (screenWidth < 1280) {
					isPc.value = false;
				} else {
					isPc.value = true;
				}
				setTimeout(() => {
					calculateSectionOffsets();
				}, 100);
			});

			setTimeout(() => {
				calculateSectionOffsets();
			}, 100);

			const scrollEl = document.getElementById(
				'layout'
			) as HTMLElement;

			const btnEl =
				document.getElementsByClassName(
					'custom-btn'
				) as unknown as HTMLElement[];

			scrollEl.addEventListener(
				'DOMMouseScroll',
				handleMouseWheelDOM
			);
			scrollEl.addEventListener(
				'wheel',
				handleMouseWheel,
				{
					passive: false,
				}
			);

			scrollEl.addEventListener(
				'touchstart',
				touchStart,
				{ passive: false }
			);
			scrollEl.addEventListener(
				'touchmove',
				touchMove,
				{ passive: false }
			);

			for (const el of btnEl) {
				el.addEventListener('touchstart', (e) => {
					log('button touch');
					// 버튼을 터치했을 때의 동작 처리
					// 스크롤 방지 코드는 필요하지 않습니다.
				});
				el.addEventListener('click', (e) => {
					log('button click');
					// 버튼을 터치했을 때의 동작 처리
					// 스크롤 방지 코드는 필요하지 않습니다.
				});
			}
			log('btn el is', btnEl);
		});

		onUnmounted(() => {
			log('onUnmounated');
			const scrollEl = document.getElementById(
				'layout'
			) as HTMLElement;
			window.removeEventListener('resize', () => {
				setTimeout(() => {
					calculateSectionOffsets();
				}, 100);
			});

			scrollEl.removeEventListener(
				'DOMMouseScroll',
				handleMouseWheelDOM
			); // Mozilla Firefox
			scrollEl.removeEventListener(
				'wheel',
				handleMouseWheel
			); // Other browsers

			scrollEl.removeEventListener(
				'touchstart',
				touchStart
			); // mobile devices
			scrollEl.removeEventListener(
				'touchmove',
				touchMove
			); //
		});
		return {
			isPc,
			lottie1,
			lottie2,
			aboutHover,
			healthHover,
			jvmphHover,
			healthFadeUp,
			jvmpFadeUp,
			healthLottie,
			hoverFn,
		};
	},
	methods: {
		//  touchMove(e: TouchEvent) {
		// 		if (inMove.value) return false;
		// 		e.preventDefault();
		// 		log('touchMove start');
		// 		const currentY = e.touches[0].clientY;
		// 		if (touchStartY.value < currentY) {
		// 			moveUp();
		// 		} else {
		// 			moveDown();
		// 		}
		// 		return false;
		// 	}
	},
};
